<template>
    <div v-if="max > 1" class="paginator">
        Page:
        <select v-model="inputValue">
            <option v-for="i in max" :key="i" :value="i">{{ i }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        current: {
            type: Number,
            default: 1,
        },
        total: {
            type: Number,
            default: 0,
        },
        size: {
            type: Number,
            default: 50,
        },
    },
    data: () => ({
        inputValue: 1,
    }),
    watch: {
        current: {
            handler(value) {
                this.inputValue = value;
            },
            immediate: true,
        },
        inputValue: {
            handler(value) {
                this.$emit('update:current', value);
            }
        }
    },
    computed: {
        max() {
            return this.total ? Math.ceil(this.total / this.size) : 0;
        }
    }
}
</script>

<style>
.paginator {
    text-align: center;
}
</style>